import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Configuration } from '../../../app.constants';
import { RecurringContributionsResponse } from './models';

@Injectable()
export class RecurringService {
  getRecurringSchedules(pageNumber: number): Observable<RecurringContributionsResponse> {
    return this.http.get(`${this.config.server}/recurring-schedules/${pageNumber}`) as Observable<RecurringContributionsResponse>;
  }

  constructor(private http: HttpClient, private config: Configuration) {}
}
